/**
 * This module contains functions for making requests to the API.
 *
 * @file api.index.js
 * @since 1.0.0
 */

import axios from 'axios';

// Selecting DOM elements
const gsgSearch = document.getElementById('gsfc-search');
const gsgSearchHelp = document.getElementById('gsfc-search-help');

/**
 * Get the feed from the API.
 *
 * @return {Promise} Promise that resolves with the API response data or rejects with an error.
 */
const getFeed = async () => {
	// If the search input element exists, update its state and the help text
	if (gsgSearch.length > 0) {
		gsgSearch.attr('disabled', 'disabled'); // Disable the search input
		gsgSearchHelp.html('Search in progress.'); // Update help text to indicate search is in progress
	}

	try {
		const filters = global.filters; // Get filters from global variable
		// Make a GET request to the feed URL with provided filters
		const response = await axios.get(global.feedUrl, {
			withCredentials: true,
			params: {
				data: filters,
			},
		});

		// Validate the response structure
		if (!validateResponseStructure(response.data)) {
			return {
				posts: [],
				post_types: [],
				total_posts: 0,
				total_pages: 0,
			};
		}

		// If the search input element exists, restore its state and the help text
		if (gsgSearch.length > 0) {
			gsgSearch.removeAttr('disabled'); // Enable the search input
			gsgSearchHelp.html('Enter a search term.'); // Update help text to prompt user to enter a search term
		}

		return response.data; // Return the data obtained from the API response
	} catch (err) {
		/*eslint no-unused-vars: "off"*/
		//console.error(err); // Log any errors that occur during the API request
	}
};

const validateResponseStructure = (response) => {
	// Check if the response is an object
	let isValid = false;
	if (typeof response == 'object') {
		//If posts is an array
		if (Array.isArray(response.posts)) {
			isValid = true;
		}
	}
	return isValid;
};

// Export the function for external use
export default { getFeed };
